import { defineComponent as _defineComponent } from 'vue'
import { Activity, PlantVariety } from 'farmdok-rest-api';

import FieldsMap from '@/fields/components/FieldsMap.vue';
import { ActivityType, Field, Product } from '@/shared/api/rest/models';
import { Data } from '@/shared/mixins/store/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitiesMapContainer',
  props: {
    fields: null,
    varieties: null,
    crops: null,
    activities: null,
    activityTypes: null
  },
  setup(__props: any) {



return { __sfc: true,FieldsMap }
}

})